const URLHelper = {
  encodeQueryParamValue: (value) => {
    if (value === null || value === undefined || value === "") {
      return "";
    }
    return encodeURIComponent(String(value));
  }
};

export default URLHelper;
